<template>
  <v-dialog v-if="aRemplacer" v-model="showDialog" persistent width="900px">
    <template v-slot:activator="{ on }">
      <v-list-item color="green" v-on="on">
        <v-list-item-icon>
          <v-icon color="green">fa-people-arrows</v-icon>
        </v-list-item-icon>
        <v-list-item-title color="green">Remplacer</v-list-item-title>
      </v-list-item>
    </template>
    <v-card v-if="showDialog">
      <s-toolbar text="Remplacement" create @close="close()" />
      <v-card-text>
        <v-row v-if="loaded">
          <v-col cols="6">
            <span class="title">Remplacé·e</span>
            <creneau-form v-model="creneauRemplaceDisplay" disabled finLeLendemain :membres="membres" />
          </v-col>
          <v-col cols="6">
            <span class="title">Remplaçant·e</span>
            <creneau-form
              v-model="creneauRemplacant"
              finLeLendemain
              :editableDate="false"
              :membres="membreRemplacantPossibles"
              @close="close()"
              @validated="createCreneauRemplacement"
            />
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import CreneauForm from './creneau-form'
import { mapActions, mapGetters } from 'vuex'
import moment from 'moment'

export default {
  name: 'creneau-create',
  components: {
    CreneauForm,
  },
  props: {
    creneauRemplace: {
      type: Object,
      required: true,
    },
    indisponibilite: {
      type: Object,
      required: false,
      default: undefined,
    },
  },
  data() {
    return {
      showDialog: false,
      creneauRemplacant: undefined,
      creneauEntier: undefined,
    }
  },
  computed: {
    ...mapGetters({
      getMembresByServiceId: 'membre/getMembresByServiceId',
      getRemplacants: 'servicePlanning/getRemplacants',
    }),
    aRemplacer() {
      return (
        this.indisponibilite &&
        !(this.getRemplacants(this.creneauRemplace).length > 0 || this.creneauRemplace.nePasRemplacer)
      )
    },
    creneauRemplaceDisplay: {
      get() {
        return this.creneauEntier
      },
      set() {},
    },
    serviceId() {
      return parseInt(this.$route.params.serviceId, 10)
    },
    membres() {
      return this.getMembresByServiceId(this.serviceId)
    },
    loaded() {
      return this.creneauRemplacant && this.creneauEntier
    },
    membreRemplacantPossibles() {
      return this.membres.filter((m) => m.membreId !== this.creneauRemplace.membre.membreId)
    },
  },
  watch: {
    async showDialog(ouvert) {
      if (!ouvert || !this.aRemplacer || !this.creneauRemplace.creneauId) return
      this.creneauEntier = await this.fetchCreneauEntierById(this.creneauRemplace.creneauId)
      this.creneauRemplacant = JSON.parse(JSON.stringify(this.creneauEntier))
      this.creneauRemplacant.creneauId = 0
      this.creneauRemplacant.membreId = undefined
      this.creneauRemplacant.membre = undefined
    },
  },
  methods: {
    ...mapActions({
      remplacerCreneau: 'servicePlanning/remplacerCreneau',
      fetchCreneauEntierById: 'servicePlanning/fetchCreneauEntierById',
      refreshPlageMembre: 'servicePlanning/refreshPlageMembre',
    }),

    versLocalDateTime(jour, borne) {
      return moment(jour)
        .startOf('day')
        .add(borne.heure, 'hours')
        .add(borne.minute, 'minutes')
        .format('YYYY-MM-DDTHH:mm:ss')
    },

    async createCreneauRemplacement(creneauValide) {
      await this.remplacerCreneau({
        remplaceId: this.creneauEntier.creneauId,
        remplacant: creneauValide.membreId,
        debut: this.versLocalDateTime(creneauValide.date, creneauValide.heureDebut),
        fin: this.versLocalDateTime(creneauValide.dateDeFin, creneauValide.heureFin),
      })
      await Promise.all(
        [creneauValide.membreId, this.creneauEntier.membreId].map((membreId) =>
          this.refreshPlageMembre({ membreId, debut: this.creneauEntier.debut, fin: this.creneauEntier.fin })
        )
      )
      this.close()
    },
    close() {
      this.showDialog = false
      this.creneauEntier = undefined
      this.creneauRemplacant = undefined
    },
  },
}
</script>

<style scoped></style>
